import _ from 'lodash'
import currencies from './currency.json'

export const getCurrencies = () => {
    return _.map(currencies, (item) => ({ value: item.cc, label: `${item.cc} (${item.symbol})` }))
}
